import { useMutation, useQueryClient } from "react-query";
import { notifications } from "@mantine/notifications";

import { deleteCustomView } from "modules/core/api/custom_views";

import { CUSTOM_VIEWS_QUERY_KEY } from "../../queries/useCustomViewsQuery";

export const useDeleteCustomViewMutation = () => {
  const queryCLient = useQueryClient();

  return useMutation({
    mutationFn: deleteCustomView,

    onSuccess: () => {
      notifications.show({
        message: "Custom view deleted",
        color: "green",
        variant: "light"
      });
    },

    onError: () => {
      notifications.show({
        message: "Failed to delete custom view",
        color: "red",
        variant: "light"
      });
    },

    onSettled: () => {
      queryCLient.invalidateQueries(CUSTOM_VIEWS_QUERY_KEY);
    }
  });
};
